import { TriState } from "./Enums";

export class InsuranceTypeSearchParameters {
    pageNumber: number = 0;
    searchText: string = "";
    id: number = 0;
    isDeleted: TriState = TriState.UseDefault;
}